import { navigateTo } from '#imports';
import { useAccountStore } from '~/store/account';

export const featureRequired = (feature: string) =>
  defineNuxtRouteMiddleware(() => {
    if (!useAccountStore().hasFeature(feature)) {
      return navigateTo('/');
    }
  });
